var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "table-content": true, "table-content-active": this.open } },
    [
      _c("h3", [_vm._v("我的待办")]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "tabList-wrap" },
        _vm._l(_vm.tabList, function(item) {
          return _c(
            "li",
            {
              key: item.value,
              staticClass: "tab-list-item",
              class: { "tabs-current": _vm.activeName === item.value },
              on: {
                click: function($event) {
                  return _vm.handClick(item)
                }
              }
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/images/common/gong_icon_lightblue.png")
                }
              }),
              _vm._v("\n      " + _vm._s(item.label) + "\n      "),
              _c("div", [
                _vm._v(
                  _vm._s(_vm.numArry[item.key] ? _vm.numArry[item.key] : "0")
                )
              ])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-box" },
        [
          _c("a-table", {
            attrs: {
              columns: _vm.columns1,
              "data-source": _vm.workList,
              loading: _vm.tableLoading,
              pagination: _vm.pagination,
              rowKey: function(record, index) {
                return index
              },
              locale: { emptyText: _vm.renderEmpty }
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "operate",
                fn: function(text, record) {
                  return [
                    _vm.activeName !== 3
                      ? _c("div", { staticClass: "operate" }, [
                          _c("div", [
                            record.cureentNodeCode === "NODE0035" &&
                            [4, 6].includes(record.progressBar)
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "btF upload-btn",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.uploadAuthorization(
                                          true,
                                          record
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              上传授权书\n            "
                                    )
                                  ]
                                )
                              : [
                                  "NODE6410",
                                  "NODE6402",
                                  "NODE6408",
                                  "NODE6416"
                                ].includes(record.cureentNodeCode)
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "btF upload-btn",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.$router.push(
                                          "/reviewOpinions"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n             去处理\n            "
                                    )
                                  ]
                                )
                              : record.serviceProgressStr !== "答复审查意见"
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "btF upload-btn",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.toJump(record)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(record.serviceProgressStr) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.uploadAuthorizationLetterVisiale
        ? _c("UploadAuthorizationLetter", {
            attrs: { currRow: _vm.currRow },
            on: {
              uploadAuthorization: _vm.uploadAuthorization,
              getList: _vm.getWorkTodoList,
              getViewWorkNum: _vm.getViewWorkNum
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("NameVerificationReportPop", {
        ref: "nvrPop",
        attrs: {
          currRow: _vm.currRow,
          workRelWorkOrderList: _vm.workRelWorkOrderList
        }
      }),
      _vm._v(" "),
      _c("IframeModal", {
        ref: "IframeModal",
        on: {
          submit: function($event) {
            _vm.getWorkTodoList()
            _vm.getViewWorkNum()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bff7198", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bff7198","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/work/components/workOrder.vue
// module id = null
// module chunks = 